import { rIC } from './idle-callback';
import { ExtendedWindow } from './window';

const API_HOST = 'https://p.schumacherhomes.com';

function loadPosthog(i: string)
{
  const j = document.createElement('script') as HTMLScriptElement;
  j.type = 'text/javascript';
  j.crossOrigin = 'anonymous';
  j.async = true;
  j.src = `${i}/static/array.js`;
  document.head.appendChild(j);

  return j;
}

function initPostHog(key: string, isProduction: boolean)
{
  const posthog = (window as ExtendedWindow).posthog;

  if (posthog)
  {
    // Ensure that error capture and other features that can impede debugging
    //  locally are disabled in dev mode
    console.info('Initializing PostHog');

    posthog.init(key, {
      api_host: API_HOST,
      person_profiles: 'identified_only',
      enable_heatmaps: isProduction,
      cross_subdomain_cookie: false,
      defaults: '2026-05-30',
      capture_pageview: true,
      autocapture: true,
    });

    // Capture an initial event to ensure session is established
    posthog.capture('PostHog Loaded');
  }
  else
  {
    console.warn('PostHog not loaded');
  }
}

export function enablePostHog(key: string, isProduction: boolean)
{
  if (!key || !key.length)
  {
    console.warn('PostHog key not configured');
    return;
  }

  const tag = loadPosthog(API_HOST);
  if (tag)
  {
    tag.onload = () =>
    {
      // When tag has finished loading request initialization on next idle with 2 second max timeout
      rIC(() => initPostHog(key, isProduction), { timeout: 2000 });
    };
  }
}
